module.exports = __webpack_public_path__ + "img/green-treetop.c2cc7d12.svg";